<template>
    <div>
        <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_url)}`" class="iframe-player"></iframe>
    </div>
</template>

<script>
export default {
    props: ['file_url']
}
</script>

<style lang="stylus" scoped>
.iframe-player
    width 100%
    height 565px
    border none
</style>
